import React from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import CustomLoadingOverlay from '../common/datagrid/CustomLoadingOverlay';
import CustomToolbar from '../common/datagrid/CustomToolbar';

const CodeList = ({ columns, loading, comCodes, error }) => {
  const [pageSize, setPageSize] = React.useState(20);
  //에러 발생시
  if (error) {
    return <div>에러 발생</div>;
  }

  return (
    <>
      <div style={{ display: 'flex', height: 'calc(100vh - 240px)' }}>
        <div style={{ flexGrow: 1 }}>
          <DataGridPro
            columns={columns}
            rows={comCodes ? comCodes : []}
            loading={loading}
            components={{
              Toolbar: CustomToolbar,
              LoadingOverlay: CustomLoadingOverlay,
            }}
            componentsProps={{
              toolbar: { fileName: '공통 코드 리스트' },
            }}
            initialState={{ pinnedColumns: { right: ['actions'] } }}
            pageSize={pageSize}
            onPageSizeChange={(newPage) => setPageSize(newPage)}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            pagination
          />
        </div>
      </div>
    </>
  );
};

export default CodeList;
